<app-floorplan-item-details [floorplanItem]="floorplanImage()" [duplicateEnabled]="false">
  <div data-main>
    @if ((isMonitoringScope$ | async) === true && imageMetadata()?.tags?.length) {
      <div class="tag-container">
        @for (tag of imageMetadata()?.tags; track tag) {
          <odx-chip removable="false" size="small" variant="secondary">
            {{ tag | translateProjectImageTag }}
          </odx-chip>
        }
      </div>
    }
    <div class="img-maximise">
      <img [src]="previewUrl()" alt="Project Image" />
      <button odxButton variant="secondary" (click)="onShowImage()">
        <odx-icon name="maximize"></odx-icon>
      </button>
    </div>
    @if (imageForm) {
      <form odxForm [formGroup]="imageForm" [disabled]="floorplanImage().locked">
        @if ((isMonitoringScope$ | async) === true) {
          <odx-form-field i18n-label="@@floorplan.details.image.form.location.label" label="Ort des Fotos">
            <input
              formControlName="name"
              odxFormFieldControl
              i18n-placeholder="@@floorplan.details.image.form.location.placeholder"
              placeholder="Ort des Fotos"
              type="text"
            />
          </odx-form-field>

          <odx-form-field i18n-label="@@floorplan.details.image.form.tags.label" label="Tags">
            <odx-select multiple formControlName="tags" odxFormFieldControl>
              @for (item of tagList$ | async | odxAutocompleteSearchFilter; track item) {
                <odx-select-option [value]="item">
                  {{ item | translateProjectImageTag }}
                </odx-select-option>
              }
              <input
                placeholder="Nach Tag suchen..."
                i18n-placeholder="@@floorplan.details.image.form.tags.placeholder"
                odxSelectSearchField="Kein Tag gefunden"
                i18n-odxSelectSearchField="@@floorplan.details.image.form.tags..noResult"
              />
            </odx-select>
          </odx-form-field>

          <odx-form-field i18n-label="@@floorplan.details.image.form.description.label" label="Beschreibung">
            <textarea formControlName="description" odxFormFieldControl></textarea>
          </odx-form-field>
        } @else {
          <odx-form-field i18n-label="@@floorplan.details.image.form.name.label" label="Name des Fotos">
            <input
              formControlName="name"
              odxFormFieldControl
              i18n-placeholder="@@floorplan.details.image.form.name.placeholder"
              placeholder="Name des Fotos"
              type="text"
            />
          </odx-form-field>
        }
      </form>
    }
  </div>
</app-floorplan-item-details>
